import type { AllarmeDinamicoDTO, NuovoAllarmeDinamicoDTO } from '@/models/dto/allarme/allarme-dinamico-dto'
import type { DynamicAlarm, NewDynamicAlarm } from '@/models/types/alarm/dynamic-alarm'
import { mapToNewAlarm, mapToNuovoAllarmeDTO } from './alarm-mapper'

const mapToDynamicAlarm = (dto: AllarmeDinamicoDTO): DynamicAlarm => {
    return { ...mapToNewDynamicAlarm(dto), id: dto.id }
}

const mapToAllarmeDinamicoDTO = (alarm: DynamicAlarm): AllarmeDinamicoDTO => {
    return { ...mapToNuovoAllarmeDinamicoDTO(alarm), id: alarm.id }
}

const mapToNewDynamicAlarm = (dto: NuovoAllarmeDinamicoDTO): NewDynamicAlarm => {
    return {
        ...mapToNewAlarm(dto),
        thresholdZ: dto.sogliaZ,
        thresholdXY: dto.sogliaXY,
        valueXY: dto.valueXY,
        valueZ: dto.valueZ,
        category: dto.category,
        type: dto.type,
    }
}

const mapToNuovoAllarmeDinamicoDTO = (alarm: NewDynamicAlarm): NuovoAllarmeDinamicoDTO => {
    return {
        ...mapToNuovoAllarmeDTO(alarm),
        sogliaZ: alarm.thresholdZ,
        sogliaXY: alarm.thresholdXY,
        valueXY: alarm.valueXY,
        valueZ: alarm.valueZ,
        type: alarm.type,
    }
}

export { mapToAllarmeDinamicoDTO, mapToDynamicAlarm, mapToNewDynamicAlarm, mapToNuovoAllarmeDinamicoDTO }
